/* Verdo scroll animations for Sense theme */
document.addEventListener("DOMContentLoaded", function() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: "0px 0px -60px 0px" });

  // Observe product cards
  document.querySelectorAll(".card-wrapper, .collection-card, .card").forEach((el, i) => {
    el.classList.add("verdo-reveal");
    el.style.transitionDelay = (i % 4) * 0.1 + "s";
    observer.observe(el);
  });

  // Observe section headings and text blocks
  document.querySelectorAll(".rich-text, .multicolumn, .collection-list, .newsletter").forEach(el => {
    el.classList.add("verdo-reveal");
    observer.observe(el);
  });
});
